/**
 * Who a menu link is shown to. The Studio stores the same values
 * (sanity/lib/navigation.ts); a test keeps the two lists in step.
 */
export const NAVIGATION_AUDIENCES = [
  'everyone',
  'loggedOut',
  'members',
  'nonUltra',
  'ultra'
] as const;

export type NavigationAudience = (typeof NAVIGATION_AUDIENCES)[number];

/** The dropdowns editors manage in Sanity, as the document's field names. */
export const SITE_NAVIGATION_MENUS = [
  'expertReveals',
  'content',
  'more'
] as const;

export type SiteNavigationMenu = (typeof SITE_NAVIGATION_MENUS)[number];

export type SiteNavigationHeading = {
  kind: 'heading';
  label: string;
};

export type SiteNavigationLink = {
  kind: 'link';
  label: string;
  href: string;
  audience: NavigationAudience;
  shouldOpenInNewTab: boolean;
  shouldInsertNextGameweek: boolean;
};

export type SiteNavigationItem = SiteNavigationHeading | SiteNavigationLink;

/**
 * The editors' menus, ready for the header. It travels in page props, so
 * every value is JSON-safe: no undefined anywhere.
 */
export type SiteNavigation = Record<
  SiteNavigationMenu,
  SiteNavigationItem[]
> & {
  /** When editors last published it, so a newer copy can win over an older one. */
  updatedAt: string;
};

/** The edge-cached route the browser checks for newer menus. */
export const SITE_NAVIGATION_API_PATH = '/api/site-navigation';
